import { SolType } from '@sol/components';
import { IntegrationRow } from './integration-row';

export class AsmIntegrationsType {
  public static readonly integrationRow = SolType.ofObject<IntegrationRow>('asm.integrationRow', {
    integrationId: SolType.string,
    label: SolType.string,
    value: SolType.string,
    platformUrl: SolType.string,
  });
}
